export default {
  regCheckCn: /[\u4E00-\u9FA5\uF900-\uFA2D]{2,80}/, // 检查中文
  // 中文姓名
  regCheckCnName: /^([\u4E00-\u9FA5\uF900-\uFA2D.]){2,50}$/,
  // 英文姓名
  regCheckEnName: /^([a-zA-Z.\s]){2,50}$/,
  // 公司
  regCheckComName: /^([\u4E00-\u9FA5\uF900-\uFA2D]|[a-zA-Z\d\s.,'_()（）-]){4,50}$/,
  // 职务
  regCheckRank: /^[/.,\sa-zA-Z\u4e00-\u9fa5\uF900-\uFA2D]{2,50}$/,
  // 部门
  regCheckDepar: /^([\u4E00-\u9FA5\uF900-\uFA2D]|[a-zA-Z\s（）()/-]){2,50}$/,
  // 手机
  regCheckCnMobile: /^1(3[0-9]|5[0-9]|8[0-9]|4[0-9]|7[0-9]|66|67|9[0-9])\d{8}$/,
  // 邮箱
  regCheckEmail: /^([a-zA-Z0-9]+[_|_|.|-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9-]+[_|_|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,4}$/,
  // regCheckEmail: /^(([a-zA-Z0-9]+[_|_|.|-]?)*[a-zA-Z0-9]+){1,12}@([a-zA-Z0-9-]+[_|_|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,4}$/,

  // 国内邮编
  checkCnZipCode: /^[0-9]{6}$/,
  // 港澳台邮编
  checkgatZipCode: /^[0-9]{5,6}$/,
  // 国外邮编
  checkEnZipCode: /^[0-9a-zA-Z]{3,}$/,
  // 地址  6-100字符
  checkAddress: /^.{6,50}$/,
  //  checkAddress:/([\u4E00-\u9FA5\uF900-\uFA2D]|[a-zA-Z\d\s.,'_()（）-]){6,100}/,
  // 国内电话、传真
  regCheckTelCn: /^([0-9]{1,4}[-]){1}([0-9]{1,4}[-]){1}([0-9]{7,8})([-][0-9]{0,5}){0,1}$/,
  // 国外电话、传真
  regCheckTelEn: /^([0-9]{1,4}[-]){1}([1-9][0-9]{4,11})([-][0-9]{0,6}){0,1}$/,
  regCheckFaxTel: /(^(\d{2,4}[-_－—]?)?\d{3,8}([-_－—]?\d{3,8})?([-_－—]?\d{1,7})?$)|(^0?1[35]\d{9}$)/,
  // 网址
  regWebUrl: /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/){0,1}(([A-Za-z0-9-~]+).)+(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~/])+$/,
  // 身份证
  // 18位
  //  regId18:/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/,
  //  regId18:/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/,
  // regId18:/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/,
  // 15位
  // regId2:/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,

  /** 护照 */
  passport1: /^[a-zA-Z]{5,17}$/,
  passport2: /^[a-zA-Z0-9]{5,17}$/,
  /** 港澳通行证验证     */
  hkmakao: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/,
  /** 台湾通行证验证     */
  taiwan1: /^[0-9]{8}$/,
  taiwan2: /^[0-9]{10}$/,
  code: /[0-9]{4}/,
  postcode: /^[0-9]{6}$/,
  password: /^[a-zA-Z0-9]{6,18}/,
  iphoneCode: /[0-9]{4}/,
  notEmpty: /^[\s\S]*.*[^\s][\s\S]*$/
}



// WEBPACK FOOTER //
// ./src/utils/regExp.js